var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinear = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-icon": "close",
  "data-variant": "linear",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.001 5 19 19M5 19 18.999 5"
})));
export { SvgLinear as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLWljb249ImNsb3NlIiBkYXRhLXZhcmlhbnQ9ImxpbmVhciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij4KCjxwYXRoIGQ9Ik01LjAwMDk4IDVMMTkgMTguOTk5MSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIC8+CjxwYXRoIGQ9Ik00Ljk5OTk2IDE4Ljk5OTFMMTguOTk5IDUiIHN0cm9rZT0iY3VycmVudENvbG9yIiAvPgo8L3N2Zz4=";